import { classes } from '@portal/components'
import React from 'react'

type Props = {
  children: React.ReactNode
  className?: string
  disablePadding?: boolean
}

const Container = ({ children, className, disablePadding }: Props) => {
  return (
    <div
      className={classes(
        'mx-auto max-w-7xl',
        {
          'px-4': !disablePadding,
        },
        className,
      )}
    >
      {children}
    </div>
  )
}

export default Container
